<template>
  <div class="d-inline-block">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          small
          color="primary"
          class="mx-0"
          v-bind="attrs"
          v-on="on"
          @click="searchRouter"
        >
          <v-icon small class="">mdi-magnify</v-icon>
        </v-btn>
      </template>
      <span> {{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import Slugify from "slugify";

export default {
  name: "MedSearchButton",
  props: {
    icon: {
      type: String,
      default: "mdi-magnify",
    },
    routeType: {
      type: String,
      required: true,
      validator: function (value) {
        return ["category", "ingredient"].indexOf(value) !== -1;
      },
    },
    itemID: {
      type: String,
      required: true,
    },
    itemName: {
      type: String,
      required: true,
    },
    itemSlug: null,
  },
  data: function () {
    return {};
  },
  methods: {
    slugText(name) {
      return Slugify(name.toLowerCase());
    },
    searchRouter() {
      let url = `/meds/${this.routeType}/${this.itemID}/`;
      url += this.slugText(this.theSlug);
      this.$router.push({ path: url });
    },
  },
  computed: {
    tooltipText: function () {
      let name = this.itemName;
      let rtn = "";
      if (this.routeType == "category") {
        rtn = `Seach all ${name} meds`;
      } else {
        rtn = `Seach all meds containing ${name}`;
      }
      return rtn;
    },
    theSlug: function () {
      return this.itemSlug ? this.itemSlug : this.itemName;
    },
  },
};
</script>

<style scoped></style>
